(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tw-cart-pending"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.twCartPending) return;

  const MAX_WAIT = 10000;
  // If the drawer's count can't be read (UpCart markup changed), lift after this.
  const UNREADABLE_WAIT = 800;

  let overlay = null;
  let pending = null;

  const isAdd = (url) => /\/cart\/add(\.js)?$/.test(url.pathname) && !url.searchParams.has('_easygift_internal');

  const drawer = () => document.querySelector('#upCart')?.shadowRoot?.querySelector('.upcart-cart');

  // UpCart's header reads "Cart • 4".
  const drawerCount = () => {
    const match = (drawer()?.innerText || '').match(/Cart\s*\S\s*(\d+)/);
    return match ? Number(match[1]) : null;
  };

  const build = () => {
    overlay = document.createElement('div');
    overlay.className = 'tw-cart-pending';
    overlay.setAttribute('role', 'status');
    overlay.setAttribute('aria-live', 'polite');
    overlay.innerHTML = '<span class="tw-cart-pending__spinner" aria-hidden="true"></span><p class="tw-cart-pending__text"></p>';
    document.body.appendChild(overlay);
  };

  // "Adding your 60-Day Supply…" from the selected plan card, or a plain fallback
  // for the one-time option and buttons outside the plan selector.
  const labelFor = (plans) => {
    const radio = plans.querySelector('[data-tw-plan-radio]:checked');
    const title = radio && radio.closest('[data-tw-card]')?.querySelector('.tw-subs__title');
    const name = title ? title.textContent.trim() : '';
    return name ? `Adding your ${name}…` : 'Adding to your cart…';
  };

  // Follow the drawer every frame, so the cover stays on it while it slides in.
  const track = () => {
    if (!pending) return;
    const rect = drawer()?.getBoundingClientRect();
    const left = rect ? Math.max(rect.left, 0) : 0;
    const right = rect ? Math.min(rect.right, window.innerWidth) : 0;
    const visible = rect && right - left > 0 && rect.height > 0;

    overlay.classList.toggle('is-active', !!visible);
    if (visible) {
      overlay.style.top = `${Math.max(rect.top, 0)}px`;
      overlay.style.left = `${left}px`;
      overlay.style.width = `${right - left}px`;
      overlay.style.height = `${Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0)}px`;
    }
    pending.frame = requestAnimationFrame(track);
  };

  const hide = () => {
    if (!pending) return;
    cancelAnimationFrame(pending.frame);
    clearTimeout(pending.cap);
    clearInterval(pending.poll);
    pending = null;
    overlay.classList.remove('is-active');
  };

  const show = (plans) => {
    if (!overlay) build();
    hide();

    const accent = getComputedStyle(plans).getPropertyValue('--tw-accent');
    if (accent) overlay.style.setProperty('--tw-accent', accent.trim());
    overlay.querySelector('.tw-cart-pending__text').textContent = labelFor(plans);

    pending = { since: performance.now(), settling: false, frame: 0, poll: 0, cap: setTimeout(hide, MAX_WAIT) };
    track();
  };

  // The shopper's item is in the cart. Lift once the drawer has redrawn with it,
  // not on the gifts-only state in between.
  const settle = () => {
    const current = pending;
    current.settling = true;

    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
      .then((response) => response.json())
      .then((cart) => {
        if (pending !== current) return;
        const expected = [cart.item_count, cart.items.length];
        const started = performance.now();

        current.poll = setInterval(() => {
          const count = drawerCount();
          if (count === null && performance.now() - started < UNREADABLE_WAIT) return;
          if (count === null || expected.includes(count)) hide();
        }, 100);
      })
      .catch(hide);
  };

  // Resource timing reports every request when it completes, whichever app made it
  // and however it was made, so this keeps working while EG and UpCart wrap fetch.
  const onEntries = (list) => {
    if (!pending || pending.settling) return;

    for (const entry of list.getEntries()) {
      if (entry.startTime < pending.since) continue;

      let url;
      try {
        url = new URL(entry.name);
      } catch (error) {
        continue;
      }

      if (url.origin === location.origin && isAdd(url)) {
        settle();
        return;
      }
    }
  };

  try {
    new PerformanceObserver(onEntries).observe({ type: 'resource' });
  } catch (error) {
    // Without resource timing there is nothing to wait on, so never show the cover.
    return;
  }

  // Capture phase, so this runs before the theme's own handler disables the button.
  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest && event.target.closest('[data-add-to-cart]');
      if (!button) return;

      const plans = document.querySelector('tw-subscription');
      if (!plans || !document.querySelector('#upCart')) return;

      // The same cases in which the theme skips the add.
      if (button.disabled || button.hasAttribute('disabled')) return;
      if (button.closest('[data-form-wrapper]')?.classList.contains('variant--soldout')) return;

      show(plans);
    },
    true
  );

  window.twCartPending = { show, hide };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tw-subscription"] && !Shopify.designMode) return;
  try {
    // The Judge.me star rating under the product title scrolls to the reviews section.
document.addEventListener('click', function (event) {
  var badge = event.target.closest && event.target.closest('.jdgm-prev-badge');
  if (!badge) return;
  var widget = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-widget.jdgm-review-widget');
  if (!widget) return;
  event.preventDefault();
  widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

class TwSubscription extends HTMLElement {
  connectedCallback() {
    this.planInput = this.planInput || this.querySelector('[data-tw-plan-input]');
    this.cards = Array.from(this.querySelectorAll('[data-tw-card]'));

    this.addEventListener('change', (event) => {
      if (event.target.matches('[data-tw-plan-radio]')) {
        this.select(event.target);
      }
    });

    this.addEventListener('click', (event) => {
      if (event.target.closest('label, a, button, input')) return;
      const card = event.target.closest('[data-tw-card]');
      const radio = card && card.querySelector('[data-tw-plan-radio]');
      if (radio && !radio.checked) {
        radio.checked = true;
        this.select(radio);
      }
    });

    // This block renders above the product form, so on first parse the form does not
    // exist yet and neither the plan input nor the variant can be set. Without this the
    // default selection reaches the cart unset — it only worked once you clicked a plan.
    const applyInitialSelection = () => {
      this.adoptInput();
      const checked = this.querySelector('[data-tw-plan-radio]:checked');
      if (checked) this.select(checked);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyInitialSelection, { once: true });
    } else {
      applyInitialSelection();
    }

    // The theme initialises its own product form after us and writes the page's variant
    // back into [data-product-select], wiping our value. Re-assert in the capture phase
    // so the correct variant is in place before the theme reads FormData on submit.
    document.addEventListener(
      'click',
      (event) => {
        if (!event.target.closest('[data-add-to-cart]')) return;
        const checked = this.querySelector('[data-tw-plan-radio]:checked');
        if (!checked) return;
        this.adoptInput();
        this.syncVariant(checked);
      },
      true
    );
  }

  get productForm() {
    const byId = this.dataset.formId ? document.getElementById(this.dataset.formId) : null;
    if (byId) return byId;

    const scope = this.closest('[data-section-id]') || document;
    return (
      scope.querySelector('form[data-product-form]') ||
      scope.querySelector('form[action*="/cart/add"]')
    );
  }

  adoptInput() {
    const form = this.productForm;
    if (!form || !this.planInput) return;

    if (this.planInput.parentElement !== form) {
      form.appendChild(this.planInput);
    }

    this.planInput.removeAttribute('form');
  }

  syncVariant(radio) {
    const form = this.productForm;
    if (!form) return;

    const field = form.querySelector('[name="id"]');
    const variantId = radio.dataset.variantId || this.dataset.defaultVariant;
    if (field && variantId) field.value = variantId;
  }

  select(radio) {
    const planId = radio.dataset.planId || '';

    this.adoptInput();

    // A row may sell a different product, so the variant has to follow the choice —
    // and fall back to the page's own variant when it doesn't.
    this.syncVariant(radio);

    if (this.planInput) {
      this.planInput.value = planId;
      this.planInput.disabled = planId === '';
    }

    this.cards.forEach((card) => {
      card.classList.toggle('is-selected', card.contains(radio));
    });

    this.dispatchEvent(
      new CustomEvent('tw-subscription:change', {
        bubbles: true,
        detail: { sellingPlanId: planId }
      })
    );
  }
}

if (!customElements.get('tw-subscription')) {
  customElements.define('tw-subscription', TwSubscription);
}
  } catch(e) { console.error(e); }
})();

})();
